// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar Default (Hidden) */
.sidebar {
  position: fixed;
  top: 0;
  left: -300px; /* Sidebar hidden by default */
  width: 300px;
  height: 100vh;
  background: white;
  box-shadow: 2px 0px 10px rgba(0, 0, 0, 0.1);
  transition: left 0.3s ease-in-out;
  z-index: 1000;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

/* Sidebar Open State */
.sidebar.open {
  left: 0;
}

/* Sidebar Header */
.sidebar-header {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.sidebar-heading {
  color: #1E1E1E;
  font-family: "Syne";
  font-weight: 600;
  font-size: 18px;
}

/* Close Icon */
.back-icon {
  cursor: pointer;
  font-size: 18px;
}

/* Search Input */
.search-input {
  width: 100%;
  padding: 10px;
  margin-top: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

/* Chat List with scroll */
.chat-list {
  margin-top: 20px;
  overflow-y: auto;
  padding-right: 4px;
}

/* Chat Sections */
.chat-section {
  margin-bottom: 15px;
}

/* Chat Item */
.chat-item {
  color: #000000;
  font-family: "Outfit";
  font-weight: 400;
  font-size: 14px;
  padding: 8px 0;
  cursor: pointer;
  transition: background 0.2s ease;
  border-radius: 6px;
  padding-left: 6px;
}

.chat-item:hover {
  background: #f2f2f2;
}

/* Chat Date Label */
.chat-date {
  color: #8C8C8C;
  font-family: "Outfit";
  font-weight: 400;
  font-size: 14px;
  padding-bottom: 1rem;
}

/* New Chat Button */
.new-chat-btn {
  width: 100%;
  padding: 10px;
  background: #00a878;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  margin-top: auto; /* Push to bottom */
}

.new-chat-btn:hover {
  background: #00916e;
}

/* Open Sidebar Button */
.open-sidebar-btn {
  position: fixed;
  top: 20px;
  left: 20px;
  padding: 10px 15px;
  background: #00a878;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  z-index: 1100;
  margin-top: 30rem;
}

.open-sidebar-btn:hover {
  background: #00916e;
}`, "",{"version":3,"sources":["webpack://./src/Pages/ChatBot/Sidebar/Sidebar.scss"],"names":[],"mappings":"AAAA,6BAAA;AACA;EACI,eAAA;EACA,MAAA;EACA,YAAA,EAAA,8BAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,2CAAA;EACA,iCAAA;EACA,aAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AACJ;;AAEA,uBAAA;AACA;EACI,OAAA;AACJ;;AAEA,mBAAA;AACA;EACG,aAAA;EACA,SAAA;EACA,mBAAA;AACH;;AACA;EACI,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAEJ;;AACA,eAAA;AACA;EACI,eAAA;EACA,eAAA;AAEJ;;AACA,iBAAA;AACA;EACI,WAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AAEJ;;AACA,0BAAA;AACA;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;AAEJ;;AACA,kBAAA;AACA;EACI,mBAAA;AAEJ;;AACA,cAAA;AACA;EACI,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,iBAAA;AAEJ;;AACA;EACI,mBAAA;AAEJ;;AACA,oBAAA;AACA;EACI,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAEJ;;AACA,oBAAA;AACA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA,EAAA,mBAAA;AAEJ;;AACA;EACI,mBAAA;AAEJ;;AACA,wBAAA;AACA;EACI,eAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;AAEJ;;AACA;EACI,mBAAA;AAEJ","sourcesContent":["/* Sidebar Default (Hidden) */\n.sidebar {\n    position: fixed;\n    top: 0;\n    left: -300px; /* Sidebar hidden by default */\n    width: 300px;\n    height: 100vh;\n    background: white;\n    box-shadow: 2px 0px 10px rgba(0, 0, 0, 0.1);\n    transition: left 0.3s ease-in-out;\n    z-index: 1000;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n}\n\n/* Sidebar Open State */\n.sidebar.open {\n    left: 0;\n}\n\n/* Sidebar Header */\n.sidebar-header {\n   display: flex;\n   gap: 1rem;\n   align-items: center;\n}\n.sidebar-heading {\n    color: #1E1E1E;\n    font-family: 'Syne';\n    font-weight: 600;\n    font-size: 18px;\n}\n\n/* Close Icon */\n.back-icon {\n    cursor: pointer;\n    font-size: 18px;\n}\n\n/* Search Input */\n.search-input {\n    width: 100%;\n    padding: 10px;\n    margin-top: 10px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n}\n\n/* Chat List with scroll */\n.chat-list {\n    margin-top: 20px;\n    overflow-y: auto;\n    padding-right: 4px;\n}\n\n/* Chat Sections */\n.chat-section {\n    margin-bottom: 15px;\n}\n\n/* Chat Item */\n.chat-item {\n    color: #000000;\n    font-family: 'Outfit';\n    font-weight: 400;\n    font-size: 14px;\n    padding: 8px 0;\n    cursor: pointer;\n    transition: background 0.2s ease;\n    border-radius: 6px;\n    padding-left: 6px;\n}\n\n.chat-item:hover {\n    background: #f2f2f2;\n}\n\n/* Chat Date Label */\n.chat-date {\n    color: #8C8C8C;\n    font-family: 'Outfit';\n    font-weight: 400;\n    font-size: 14px;\n    padding-bottom: 1rem;\n}\n\n/* New Chat Button */\n.new-chat-btn {\n    width: 100%;\n    padding: 10px;\n    background: #00a878;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 14px;\n    margin-top: auto; /* Push to bottom */\n}\n\n.new-chat-btn:hover {\n    background: #00916e;\n}\n\n/* Open Sidebar Button */\n.open-sidebar-btn {\n    position: fixed;\n    top: 20px;\n    left: 20px;\n    padding: 10px 15px;\n    background: #00a878;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    z-index: 1100;\n    margin-top: 30rem;\n}\n\n.open-sidebar-btn:hover {\n    background: #00916e;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
